<template>
  <layout-vendor-dashboard-inner
    :vendor-id="vendorId"
    :back-link="{ name: 'company-vendorId-dashboard-brands', params: { vendorId } }">
    <div class="vendor-brand-create">
       <crud-create
        ref="crudCreate"
        v-bind="createConfiguration"
        ></crud-create>
    </div>
  </layout-vendor-dashboard-inner>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import CrudCreate from "@/client/components/crud/customV1/Create.vue";
import Block from "@/client/components/base/frameworks/we/html/Block";
import vendorBrandCreateFromConfigFactory from "@/client/applications/justopp/assets/static/forms/vendorBrandFormFactory.js";

export default {
  components: { CrudCreate },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.vendorBrandCreate.pageTitle",
      subTitle: "justopp.vendorBrandCreate.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    requireVendorOrAdmin: { vendorIdFromParam: "vendorId" },
  },
  meta: "justopp.vendorBrandCreate.browserTitle",
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },

  data() {
    return {
      showLoadDealUi: false,
      createConfiguration: {
        showTopSubmitButton: false,
        subject: "brand",
        submitUrl: "justopp/brand",
        showCancelButton: false,
        initialItemData: {  },
        cancelRedirect: {
          name: "company-vendorId-dashboard-brands",
          params: { vendorId: this.vendorId },
        },
        successRedirect: {
          name: "company-vendorId-dashboard-brands",
          params: { vendorId: this.vendorId },
        },
        formConfig: vendorBrandCreateFromConfigFactory({
          vendorId: this.vendorId,
          userProfile: this.$store.getters["user/profile"],
        }),
      },
      asyncData: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    //  this.productForm.adjustTypes([], true);
  },
  mounted() {

  },
  activated() {

  },
  methods: {

  },
};
</script>

<style lang="scss">

</style>

<style lang="scss" scoped></style>
